import { CardPack, Playable, PlayableId } from "./types";
import { loadCardPacks, loadPlayables } from "./utils/dataLoader";

export class DataManager {
  private static instance: DataManager | null = null;
  private _cardPacks: CardPack[] = [];
  private _playables: Map<PlayableId, Playable> = new Map();
  private _isLoaded = false;

  private constructor() {}

  static getInstance(): DataManager {
    if (!DataManager.instance) {
      DataManager.instance = new DataManager();
    }
    return DataManager.instance;
  }

  async loadGameData(): Promise<void> {
    if (this._isLoaded) {
      return;
    }

    try {
      // Load data from JSON files
      this._playables = loadPlayables();
      this._cardPacks = loadCardPacks();
      this._isLoaded = true;

      console.log(`Loaded ${this._cardPacks.length} card packs`);
      console.log(`Loaded ${this._playables.size} playables`);
    } catch (error) {
      console.error("Failed to load game data:", error);
      throw new Error("Failed to load game data");
    }
  }

  get cardPacks(): CardPack[] {
    if (!this._isLoaded) {
      throw new Error("Game data not loaded. Call loadGameData() first.");
    }
    return this._cardPacks;
  }

  get playables(): Map<PlayableId, Playable> {
    if (!this._isLoaded) {
      throw new Error("Game data not loaded. Call loadGameData() first.");
    }
    return this._playables;
  }

  getPlayable(playableId: PlayableId): Playable {
    const playable = this._playables.get(playableId);
    if (!playable) {
      throw new Error(`Missing playable ${playableId}`);
    }
    return playable;
  }

  getPack(name: string): CardPack | undefined {
    return this._cardPacks.find(({ name: packName }) => name === packName);
  }

  get isLoaded(): boolean {
    return this._isLoaded;
  }
}
